import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../services/config.service';

@Injectable()
export class EmailService {
    private readonly http = inject(HttpClient);
    private readonly config = inject(ConfigService);

    getEmailContentForActivity(activityId: string): Observable<string> {
        return this.http.get(
            `${
                this.config.getConfiguration().API_BASE
            }/email/${activityId}/content`,
            {
                responseType: 'text',
            }
        );
    }
}
